import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import {
  grammarItemResponseSchema,
  grammarPointSummarySchema,
  grammarUserStateSchema,
} from '../schemas';

const grammarWorkoutV2EntrySchema = z.object({
  point: grammarPointSummarySchema,
  state: grammarUserStateSchema.nullable(),
  item: grammarItemResponseSchema,
  isNew: z.boolean(),
});

const getGrammarWorkoutV2DataSchemaDefinition = z.object({
  items: z.array(grammarWorkoutV2EntrySchema),
  reason: z.enum(['ok', 'caught_up', 'content_exhausted']),
  serveToken: z.string(),
});

export const getGrammarWorkoutV2DataSchema: typeof getGrammarWorkoutV2DataSchemaDefinition =
  getGrammarWorkoutV2DataSchemaDefinition;

export type IGetGrammarWorkoutV2Data = z.infer<typeof getGrammarWorkoutV2DataSchema>;

export type GrammarWorkoutV2ReasonType = IGetGrammarWorkoutV2Data['reason'];

export const getGrammarWorkoutV2ResponseSchema: z.ZodSchema<IAPI<IGetGrammarWorkoutV2Data>> =
  createApiResponseSchema(getGrammarWorkoutV2DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarWorkoutV2Data>
  >;

export type IGetGrammarWorkoutV2Response = IAPI<IGetGrammarWorkoutV2Data>;
